import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MapViewButton from '@material-ui/icons/MapOutlined';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import LocationStyles from './__styles__/Location.styles';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';

export class Location extends Component {
  static propTypes = {
    locationType: PropTypes.string.isRequired,
    locationName: PropTypes.string,
    locationAddress: PropTypes.string,
    locationStateInfo: PropTypes.string,
    locationDockTime: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    contactPhone: PropTypes.string,
    contactEmail: PropTypes.string,
    notes: PropTypes.string,
    onMapClick: PropTypes.func.isRequired
  };

  render() {
    const {
      classes,
      locationType,
      locationName,
      locationAddress,
      locationStateInfo,
      locationDockTime,
      firstName,
      lastName,
      contactPhone,
      contactEmail,
      notes,
      t,
      onMapClick
    } = this.props;

    return (
      <section>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline7, classes.title)}>
            {locationType}
            <IconButton
              onClick={onMapClick}
              classes={{
                root: classes.titleIcon
              }}
              color={'primary'}
            >
              <MapViewButton />
            </IconButton>
          </h1>
        </div>

        <Grid container spacing={16}>
          <Grid item lg={6} zeroMinWidth>
            <h2 className={classes.subtitle2}>{t('Location')}</h2>
            <p className={classes.body2Light}>{locationName}</p>
            <p className={classes.body2Light}>{locationAddress}</p>
            <p className={classes.body2Light}>{locationStateInfo}</p>
            <p className={classes.body2Light}>{locationDockTime}</p>
          </Grid>
          <Grid item lg={6} zeroMinWidth>
            <h2 className={classes.subtitle2}>{t('Contact')}</h2>
            <p className={classes.body2Light}>{`${firstName} ${lastName}`}</p>
            <p className={classes.body2Light}>{contactPhone}</p>
            <p className={classes.body2Light}>{contactEmail}</p>
          </Grid>
          <Grid item lg={12}>
            <h2 className={classes.subtitle2}>{t('Notes')}</h2>
            <p className={classes.body2Light}>{notes}</p>
          </Grid>
        </Grid>
      </section>
    );
  }
}

const translatedLocation = withNamespaces()(Location);

export default withStyles(
  combineStyles(LocationStyles, LayoutStyles, TypographyStyles)
)(translatedLocation);
